import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { CacheControlInterceptor } from './cache-control.interceptor';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { BaseUrlInterceptor } from './base-url.interceptor';
import { AuthInterceptor } from './auth.interceptor';
import { UserImpersonationInterceptor } from './user-impersonation.interceptor';

@NgModule({
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CacheControlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UserImpersonationInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
  ],
})
export class InterceptorModule {
  
}
